const MapeoDeIds = {
  'Pagada en JDE': 'Pagada',
  'Anulada': 'Rechazado',
  'Cheque Anulado en JDE': 'Rechazado',
  'Pago Anulado en JDE': 'Rechazado',
  'Rechazada': 'Rechazado'
};

// Método para obtener el valor de cadena a partir del id
function obtenerValorEstado (estado) {
  const valorString = MapeoDeIds[estado];
  if (valorString === undefined) {
    return 'En Proceso';
  }
  return valorString;
}

export {obtenerValorEstado}